import { Map } from 'immutable';

/**
 * Utility function to sort state object
 * @param {any} state - The state object to sort
 * @returns {any} - Sorted state object
 */
export const sortStateObject = (state: any): any => {
    // Handle Immutable objects
    if (Map.isMap(state)) {
        return state.sortBy((v, k) => k);
    }

    // Handle plain JavaScript objects
    if (typeof state === 'object' && state !== null && !Array.isArray(state)) {
        return Object.keys(state)
            .sort()
            .reduce<Record<string, any>>((result, key) => {
                result[key] = state[key];
                return result;
            }, {});
    }

    return state;
};

/**
 * Safely stringify values without circular references
 * @param {any} obj - Object to stringify
 * @param {number} maxDepth - Maximum depth to traverse
 * @returns {string} - JSON string representation of the object
 */
export const safeStringify = (obj: any, maxDepth = 2): string => {
    const seen = new WeakSet();

    return JSON.stringify(
        obj,
        (key, value) => {
            // Handle Immutable.js objects
            if (Map.isMap(value)) {
                return '[Immutable Map]';
            }
            if (
                value &&
                typeof value === 'object' &&
                typeof value.isList === 'function' &&
                value.isList()
            ) {
                return '[Immutable List]';
            }

            // Skip functions and DOM elements that might cause circular refs
            if (typeof value === 'function') {
                return '[Function]';
            }

            if (
                (typeof Element !== 'undefined' && value instanceof Element) ||
                (typeof value === 'object' && value !== null && value.nodeType)
            ) {
                return '[DOM Element]';
            }

            // Handle circular references
            if (typeof value === 'object' && value !== null) {
                if (seen.has(value)) {
                    return '[Circular]';
                }
                seen.add(value);
            }

            return value;
        },
        2,
    );
};
